import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, LayoutGrid, BookOpen } from 'lucide-react';

const items = [
  { label: 'Accueil', path: '/', icon: LayoutDashboard },
  { label: 'Apps', path: '/apps', icon: LayoutGrid },
  { label: 'Docs', path: '/docs', icon: BookOpen },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="flex w-full items-center justify-around bg-white py-2 dark:bg-slate-950">
      {items.map((item) => {
        const active =
          item.path === '/'
            ? location.pathname === '/'
            : location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);
        const Icon = item.icon;
        return (
          <button
            key={item.path}
            type="button"
            onClick={() => navigate(item.path)}
            className="flex flex-col items-center gap-0.5 px-2 py-1"
          >
            <Icon size={20} className={active ? 'text-orange-500' : 'text-slate-400'} />
            <span className={`text-[10px] font-medium ${active ? 'text-orange-500' : 'text-slate-400'}`}>
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
